import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#FF0EA2',
        secondary: '#22265E',
        accent: '#8c9eff',
        error: '#FF4242',
        success: '#80D39B',
        warning: '#F5B700',
      },
    },
  },
})
